<template>
    <div class="beneficios-section">
        <div class="beneficios-content">
            <h2 class="beneficios-title fuente-posm">
                ¿Cuáles son los <br>Beneficios Clave?
            </h2>
            <p class="beneficios-text fuente-nova">
                Nuestra solución te permite administrar todos tus pedidos en línea desde una sola plataforma, además de contar con tu propia tienda en línea.
            </p>
        </div>
        <div class="beneficios-video">
            <video controls :poster="posterUrl">
                <source :src="videoUrl" type="video/mp4">
            </video>
        </div>
    </div>
</template>

<script>
export default {
    name: 'BeneficiosClaveNew',
    data() {
        return {
            posterUrl: require('@/assets/images/a17.webp'),
            videoUrl: require('@/assets/images/BO.mp4')
        }
    }
}
</script>

<style lang="css" scoped>
.beneficios-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 60px;
    background-color: #272727;
}

.beneficios-content {
    flex: 1;
    max-width: 600px;
}

.beneficios-title {
    color: var(--color-5);
    font-size: 70px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.beneficios-text {
    color: var(--color-5);
    font-size: 29px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

.beneficios-video {
    flex: 0 0 auto;
    max-width: 500px;
}

.beneficios-video video {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .beneficios-title {
        font-size: 60px;
    }

    .beneficios-text {
        font-size: 27px;
    }

    .beneficios-video {
        max-width: 400px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .beneficios-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 0;
    }

    .beneficios-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .beneficios-video {
        order: 2;
        width: 100%;
        max-width: none;
        margin-top: 60px;
        display: flex;
        justify-content: center;
    }

    .beneficios-video video {
        width: 90%;
        max-width: none;
    }

    .beneficios-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .beneficios-text {
        font-size: 16px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
